<div class="panel panel-default">
  <div class="panel-body padding-small">
    <div class="grid-1">
      <h2 class="mt-02">{{ partnerResolver.ArtifactName }}</h2>

      <label class="control control-checkbox" style="cursor: pointer">
        Enabled
        <input type="checkbox" [(ngModel)]="partnerResolver.IsEnabled" />
        <i></i>
      </label>
    </div>
    @if (partnerResolver.ConfigurationDataFields?.length > 0 && partnerResolver.IsEnabled) {
      <div>
        <div class="row">
          <div class="col-md-6">
            <button class="btn btn-link padding-small" (click)="showConfiguration = !showConfiguration">{{ showConfiguration ? 'Hide configuration' : 'Show configuration' }}</button>
          </div>
          <div class="col-md-6">
            @if (!isFormValid) {
              <p class="error">
                <small>Some settings needs attention</small>
              </p>
            }
          </div>
        </div>
        <div [hidden]="!showConfiguration">
          <ep-datafield-group-container #groupContainer
            [numberOfColumns]="1"
            [datafieldGroups]="partnerResolver.ConfigurationDataFields"
            [isAlwaysEditable]="true"
            [formValidationGroup]="formGroup">
          </ep-datafield-group-container>
        </div>
      </div>
    }
  </div>
</div>